/*                                                          */
export async function coerseFunctionOrValue<T, Args extends any[]>(
  value: T | Promise<T> | ((...a: Args) => T | Promise<T>),
  ...args: Args
): Promise<T> {
  return typeof value === "function" ? (value as (...a: Args) => T | Promise<T>)(...args) : value;
}

/*                                                          */
export function noop(v: any = {}): any {
  return v;
}
